// extracted by mini-css-extract-plugin
export default {"advertTab":"_6pDjbZ-s"};